import { getParser } from '../../util/parser';


export const FORMULA_REGEX = /{{([^}]+)}}/;
export const FORMULAS_REGEX = /{{([^}]+)}}/g;
export const VARIABLE_REGEX = /\$([A-Za-z-_0-9]+)/;
export const VARIABLES_REGEX = /\$([A-Za-z-_0-9]+)/g;
export const VARIABLE_KEY_REGEX = /([A-Za-z-_0-9]+)/;

export const VARIABLE_PROHIBITED_NAMES = ['applicantExternalAccess', 'applicantExternalId', 'applicantAnonymousIdentifier'];


export function containsFormula(string) {
    return string && typeof string === 'string' && FORMULA_REGEX.test(string);
}

export function containsVariable(string) {
    return string && VARIABLE_REGEX.test(string);
}

export function getFormulaVariableKeys(formula) {
    const keys = [];
    if(formula && typeof formula === 'string') {
        // const matches = formula.matchAll(VARIABLES_REGEX);
        // We use exec regex function for browser compatibility, see: https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/RegExp/exec#Compatibilit%C3%A9_des_navigateurs
        let result;
        while((result = VARIABLES_REGEX.exec(formula)) !== null) {
            if(result && result[1]) {
                keys.push(result[1]);
            }
        }
    }
    // console.log('keys found in formula', keys);
    return keys;
}

export function getTextFormulas(text) {
    const formulas = [];
    if(text && typeof text === 'string') {
        // const matches = text.matchAll(FORMULAS_REGEX);
        // if(matches) {
        //     for(const match of matches) {
        //         formulas.push(match[0]); // We want the formula with {{ my_formula }}
        //     }
        // }
        let result;
        while((result = FORMULAS_REGEX.exec(text)) !== null) {
            if(result && result[0]) {
                formulas.push(result[0]); // We want the formula with {{ my_formula }}
            }
        }
    }
    return formulas;
}

/*
 * Iterate recursively on selectVariableValue until all variables in formula are found
 * variables param is an array containing variable data (key, values, range,...)
 */
export function getVariablesValues(variables) {
    const values = {};
    let iterationLimit = 0;
    while(Object.keys(values).length < variables.length && iterationLimit < 100) {
        variables.forEach(variable => {
            const selectedValue = selectVariableValue(variable);
            if(containsFormula(selectedValue) || containsVariable(selectedValue)) {
                const result = calculateFormula(selectedValue, values);
                if(result) {
                    values[variable.key] = result;
                }
            } else {
                values[variable.key] = parseFloat(selectedValue) === selectedValue ? parseFloat(selectedValue) : selectedValue;
            }
        });
        iterationLimit++;
    }
    return values;
}

export function selectVariableValue(variable) {
    if(variable) {
        if(variable.range && variable.range.min && variable.range.max && variable.range.step) {
            const { min, max, step } = variable.range;
            const realMin = Math.min(min, max);
            const realMax = Math.max(min, max);
            const rangeValue = realMax - realMin;
            const steps = Math.ceil(rangeValue / step);
            // console.log(realMin, realMax, rangeValue, steps);
            const random = Math.round(Math.random() * steps);
            return Math.round((realMin === parseFloat(min) ? realMin + (random * step) : realMin - (random * step)) * 100000) / 100000;
        } else if(variable.values && variable.values.length) {
            const random = Math.floor(Math.random() * variable.values.length);
            // console.log(variable.values, random, variable.values[random]);
            return variable.values[random];
        }
    }
    return '';
}

/*
 * Format formula to remove braces {{ }} and remove $ character before variable key
 */
export function getEscapedFormula(formula, values) {
    const keys = getFormulaVariableKeys(formula);
    const missValues = keys && keys.length ? !keys.every(key => values[key]) : false;
    if(missValues) {
        // console.log('MISS VALUES', formula, values);
        return null;
    }

    let escapedFormula = formula
        .replace('{{', '')
        .replace('}}', '')
        .replace(/\s/g, '')
        .replace(/&nbsp;/g, '');

    // console.log(keys);
    if(keys && keys.length) {
        keys.forEach(key => {
            escapedFormula = escapedFormula.replace(`$${key}`, key);
        });
    }
    // console.log('escapedFormula', escapedFormula);
    return escapedFormula;
}

/*
 * Calculate the result of a formula
 * formula param contains a string with {{$X + $Y}} or {{$X}} format
 * values param is an object and contains variable value, ex: {key1: 'value1', key2: 123}
 */
export function calculateFormula(formula, values = {}) {
    try {
        return getParser().evaluate(getEscapedFormula(formula, values), values);
    } catch (err) {
        // console.error('Parser.evaluate error', err);
        return null;
    }
}

export function displayTextWithFormula(text, values) {
    if(text && typeof text !== 'string') {
        return '';
    }
    const formulas = getTextFormulas(text);
    // console.log('formulas', text, formulas);
    formulas.forEach(formula => {
        // console.log('Replace ', formula, ' by ', calculateFormula(formula, values) || '');
        text = text.replace(formula, calculateFormula(formula, values) || '');
    });
    return text || '';
}

export function checkVariables(texts, availableVariables = []) {
    if(!Array.isArray(texts)) {
        texts = [texts];
    }
    if(texts && texts.length) {
        return texts.every(text => {
            const formulas = getTextFormulas(text);
            return formulas.every(formula => {
                const variables = getFormulaVariableKeys(formula);
                return variables.every(variableKey => availableVariables.find(availableVariable => variableKey === availableVariable.key));
            });
        });
    }
    return true;
}
